
import Vue from 'vue';
import BviqLogo from '@/components/BviqLogo.vue';
import StatusBar from '@/components/Forms/StatusBar.vue';
import { webHost } from '@/config';
import { oauthAuthorize } from '@/oauth-fetch';
import CredStore from '@/CredStore';
import { apolloClient } from '@/apolloClient';
import MyPerms, { MyPermQuery } from '@/gql/MyPerms';
import IaCardText from '@/components/IaCardText.vue';
import IaCard from '@/components/IaCard.vue';

export default Vue.extend({
  name: 'Login',
  data() {
    return {
      status: '',
      error: '',
      email: '',
      password: '',
    };
  },
  methods: {
    login() {
      this.status = '';
      if (!this.email) {
        this.error = 'An Email address is required';
        return;
      }
      if (!this.password) {
        this.error = 'A Password is required';
        return;
      }
      this.error = '';
      this.status = 'Logging in...';
      oauthAuthorize(
        `${webHost}/~oauth2`,
        (access, refresh) => {
          CredStore.accessToken = access;
          CredStore.refreshToken = refresh;
          CredStore.email = this.email;
        },
        this.email,
        this.password
      )
        .then(async (data) => {
          this.status = this.error = '';
          const perm = await apolloClient.query<MyPermQuery>({
            query: MyPerms,
          });
          CredStore.inspector = perm.data.perms.inspector;
          CredStore.approver = perm.data.perms.approver;
          CredStore.creator = perm.data.perms.creator;
        })
        .catch((error: Error) => {
          this.status = '';
          this.error = error.toString();
        });
    },
  },
  computed: {},
  components: {
    IaCard,
    IaCardText,
    BviqLogo,
    StatusBar,
  },
});
